const channel = new BroadcastChannel('auth-sync');
let isSyncing = false;

export default function authSyncPlugin(store) {
  store.subscribe((mutation) => {
    if (mutation.type === 'auth/oidc/clearAuth' && !isSyncing) {
      channel.postMessage({ type: 'logout' });
    }
  });

  channel.onmessage = (event) => {
    if (event.data?.type === 'logout') {
      isSyncing = true;
      store.commit('auth/oidc/clearAuth');
      isSyncing = false;

      if (window.location.hash !== '#/') {
        window.location.hash = '#/';
      }
    }
  };
}
